"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MuseumIcon = MuseumIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MuseumIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 9.1C20.5523 9.1 21 8.65228 21 8.1V7.82066C21 7.49434 20.8408 7.18855 20.5735 7.00142L12.5735 1.40142C12.2291 1.1604 11.7709 1.1604 11.4265 1.40142L3.42654 7.00142C3.15921 7.18855 3 7.49434 3 7.82066V8.1C3 8.65228 3.44772 9.1 4 9.1H4.8V17.2H3.9C3.40294 17.2 3 17.6029 3 18.1C3 18.5971 3.40294 19 3.9 19H20.1C20.5971 19 21 18.5971 21 18.1C21 17.6029 20.5971 17.2 20.1 17.2H19.2V9.1H20ZM15.6 15.4H13.8V11.8L12 14.5L10.2 11.8V15.4H8.4V9.1H10.2L12 11.8L13.8 9.1H15.6V15.4Z",
    fill: "currentColor"
  }));
}